.page {
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding: 24px;
}

.form {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 32px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
}

.title {
  margin-top: 12px;
  font-size: 1.75rem;
  font-weight: 800;
  font-stretch: 112%;
  letter-spacing: -0.03em;
  line-height: 1.1;
}

.error {
  margin: 0;
  padding: 12px 14px;
  border: 1px solid var(--status-busy);
  color: var(--text-primary);
  font-size: 0.9375rem;
}
